import PropTypes from 'prop-types';
import { Typography, Box, Accordion, AccordionSummary, Stack, Checkbox, Autocomplete, TextField } from '@mui/material';
import { ArrowDownward } from '@mui/icons-material';

PurchasingGroupIntegrationsFrom.propTypes = {
  formValue: PropTypes.object,
  setFormValue: PropTypes.func,
  integrations: PropTypes.array,
  title: PropTypes.string
}

export default function PurchasingGroupIntegrationsFrom({ formValue, setFormValue, integrations, title }) {
  const removeIntegration = (integration, list) => list.filter(val => !(val.integrationId === integration.integrationId &&
    val.integrationTypeId === integration.integrationTypeId));

  return <Box sx={{ border: "solid thin rgb(43 45 47 / 24%)" }}>
    <Accordion>
      <AccordionSummary expandIcon={<ArrowDownward />}>
        <Typography component="span">{title}</Typography>
      </AccordionSummary>
      <Stack sx={{ mx: 2, mb: 2 }} spacing={1} >
        {integrations.map((integration, index) => {
          const integrationValue = formValue.integrations.find(integrationValue => integrationValue.integrationId === integration.integrationId
            && integrationValue.integrationTypeId === integration.integrationTypeId);
          return <Box key={index} display="flex" justifyContent="space-between" alignItems="center">
            <Checkbox checked={!!integrationValue}
              onChange={(e) => setFormValue(value => ({
                ...value, integrations: e.target.checked ? [...formValue.integrations, {
                  integrationId: integration.integrationId,
                  integrationTypeId: integration.integrationTypeId,
                  integrationIdentityId: 0
                }] : removeIntegration(integration, formValue.integrations)
              }))} />
            {integration.name}
            <Autocomplete
              disabled={!integrationValue}
              sx={{ width: 200 }}
              size="small"
              value={integration.identities.find(identity => identity.value === integrationValue?.integrationIdentityId) ?? null}
              onChange={(e, val) => setFormValue(value => ({
                ...value, integrations: [...removeIntegration(integration, formValue.integrations),
                {
                  integrationId: integration.integrationId,
                  integrationTypeId: integration.integrationTypeId,
                  integrationIdentityId: val?.value ?? 0
                }]
              }))}
              options={integration.identities}
              renderInput={(params) => <TextField {...params} placeholder="Identity" />}
            />
          </Box>
        })}
      </Stack>
    </Accordion>
  </Box>;
}
